<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-input
        placeholder="请输入游戏名称"
        v-model="searchValue"
        class="input-with-select search-input"
        @keydown.native.enter="searchGameList"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="searchGameList"
        ></el-button>
      </el-input>
      <div>
        <el-button type="primary" plain @click="exportGame()">导出</el-button>
        <el-button type="success" plain @click="gameAddDialog"
          >游戏新增</el-button
        >
      </div>
    </div>
    <!-- 游戏列表展示 -->
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="id" label="ID" width="150"> </el-table-column>
      <el-table-column prop="created_at" label="注册日期"> </el-table-column>
      <el-table-column prop="name" label="游戏名称"> </el-table-column>
      <el-table-column prop="sms_title" label="短信抬头"> </el-table-column>
      <el-table-column prop="unique_name" label="唯一名称"> </el-table-column>
      <el-table-column label="游戏图标">
        <template slot-scope="scope">
          <img :src="scope.row.icon" alt="" class="gameIcon" />
        </template>
      </el-table-column>
      <el-table-column prop="description" label="游戏描述"> </el-table-column>
      <el-table-column prop="is_show" label="是否显示">
        <template slot-scope="scope">
          <span>{{ scope.row.is_show == 1 ? '是' : '否'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="notice_order_amount" label="单笔充值通知金额">
      </el-table-column>
      <el-table-column prop="alert_register_to_pay" label="每日新增X人注册无付费告警">
      </el-table-column>
      <el-table-column prop="close_game" label="是否停运关服">
        <template slot-scope="scope">
          <span>{{ scope.row.close_game == 1 ? '是' : '否'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="service_cost" label="本月服务器成本"> </el-table-column>
      <el-table-column prop="servece_num" label="当前服务器数量"> </el-table-column>
      <el-table-column prop="sort" label="排序"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div style="margin-bottom: 10px">
            <el-button type="primary" plain @click="cpCopy(scope.row.id)"
              >cp对接参数</el-button
            >
          </div>
          <div style="margin-bottom: 10px">
            <el-button type="success" plain @click="cpAdvanced(scope.row)"
              >游戏高级设置</el-button
            >
          </div>
          <el-button
            type="warning"
            icon="el-icon-edit"
            plain
            @click="gameEditDialog(scope.row)"
          ></el-button>

          <el-button
            type="danger"
            icon="el-icon-delete"
            plain
            @click="deleteUser(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>

    <!-- 新增游戏对话框 -->
    <el-dialog
      title="新增游戏"
      :visible.sync="addDialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addform"
        :rules="rules"
        label-width="130px"
        ref="addform"
      >
        <el-form-item label="游戏名称" prop="name">
          <el-input v-model="addform.name"></el-input>
        </el-form-item>
        <el-form-item label="唯一名称" prop="unique_name">
          <el-input v-model="addform.unique_name"></el-input>
        </el-form-item>
        <el-form-item label="短信抬头" prop="sms_title">
          <el-input v-model="addform.sms_title"></el-input>
        </el-form-item>
        <el-form-item label="游戏描述" prop="description">
          <el-input v-model="addform.description"></el-input>
        </el-form-item>
        <el-form-item label="单笔充值通知金额" prop="notice_order_amount">
          <el-input v-model="addform.notice_order_amount"></el-input>
        </el-form-item>
        <el-form-item label="是否允许使用余额支付：">
          <el-radio-group v-model="addform.is_money_pay">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否显示：">
          <el-radio-group v-model="addform.is_show">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否停运关服：">
          <el-radio-group v-model="addform.close_game">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="本月服务器成本" prop="service_cost">
          <el-input v-model="addform.service_cost"></el-input>
        </el-form-item>
        <el-form-item label="当前服务器数量" prop="servece_num">
          <el-input v-model="addform.servece_num"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="addform.sort"></el-input>
        </el-form-item>
        <el-form-item label="年龄">
          <el-select
            v-model="addform.age"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in ageList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提示内容:">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="addform.age_content"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="游戏Icon">
          <el-upload
            class="avatar-uploader"
            :action="host + 'admin/file_upload/image'"
            ref="upload"
            :show-file-list="false"
            :auto-upload="true"
            :on-success="onUploadSuccess"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <el-button v-else type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="每日新增X人注册无付费告警" prop="alert_register_to_pay">
          <el-input v-model="addform.alert_register_to_pay"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addGameSubmit('addform')"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 游戏高级设置 -->
    <el-dialog
      title="游戏高级设置"
      :visible.sync="dialogAdvancedVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        :model="advancedForm"
        label-width="156px"
        ref="advancedForm"
      >
        <el-form-item label="是否禁止登陆:">
          <el-radio-group v-model="advancedForm.is_login_suspended">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否踢下线:">
          <el-radio-group v-model="advancedForm.is_kick">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>、
        <el-form-item label="是否禁止下载:">
          <el-radio-group v-model="advancedForm.is_stop_download">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否禁止支付:">
          {{ advancedForm.is_pay_suspended }}
          <el-radio-group v-model="advancedForm.is_pay_suspended">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="登录限制状态">
          <el-select v-model="advancedForm.login_suspend_status" placeholder="请选择">
            <el-option
              v-for="item in [
                {
                  value: 1,
                  label: '限制用户'
                },
                {
                  value: 2,
                  label: '限制用户+设备GDID'
                },
                {
                  value: 3,
                  label: '限制用户+设备GDID+IP'
                },
              ]"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAdvancedVisible = false">取 消</el-button>
        <el-button type="primary" @click="advancedFormSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 编辑游戏对话框 -->
    <el-dialog
      title="编辑游戏"
      :visible.sync="editDialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editform"
        :rules="rules"
        label-width="130px"
        ref="editform"
      >
        <el-form-item label="游戏名称" prop="name">
          <el-input v-model="editform.name"></el-input>
        </el-form-item>
        <el-form-item label="游戏备注" prop="remark">
          <el-input v-model="editform.remark"></el-input>
        </el-form-item>
        <el-form-item label="短信抬头" prop="sms_title">
          <el-input v-model="editform.sms_title"></el-input>
        </el-form-item>
        <el-form-item label="游戏描述" prop="description">
          <el-input v-model="editform.description"></el-input>
        </el-form-item>
        <el-form-item label="单笔充值通知金额" prop="notice_order_amount">
          <el-input v-model="editform.notice_order_amount"></el-input>
        </el-form-item>
        <el-form-item label="是否允许使用余额支付：">
          <el-radio-group v-model="editform.is_money_pay">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否显示：">
          <el-radio-group v-model="editform.is_show">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否停运关服：">
          <el-radio-group v-model="editform.close_game">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="本月服务器成本" prop="service_cost">
          <el-input v-model="editform.service_cost"></el-input>
        </el-form-item>
        <el-form-item label="当前服务器数量" prop="servece_num">
          <el-input v-model="editform.servece_num"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="editform.sort"></el-input>
        </el-form-item>
        <el-form-item label="年龄">
          <el-select
            v-model="editform.age"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in ageList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提示内容:">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="editform.age_content"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="游戏Icon">
          <el-upload
            class="avatar-uploader"
            :action="host + 'admin/file_upload/image'"
            ref="upload"
            :show-file-list="false"
            :auto-upload="true"
            :on-success="onUploadSuccess"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <el-button v-else type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="每日新增X人注册无付费告警" prop="alert_register_to_pay">
          <el-input v-model="editform.alert_register_to_pay"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editGameSubmit('editform')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { throttle } from "@/assets/js/public.js";
import { urlSplicing } from "@/assets/js/public.js";
export default {
  name: "games",
  components: {},
  data() {
    return {
      dialogAdvancedVisible: false,
      advancedForm: {
        id: "",
        is_login_suspended: 0,
        is_kick: 0,
        login_suspend_status: 1,
        is_stop_download: 0,
        is_pay_suspended: 0,
      },
      loadingData: false,
      limit: 1,
      action: "",
      imageUrl: "",
      searchValue: "",
      historyValue: "",
      tableHeight: 0,
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      addDialogFormVisible: false,
      editDialogFormVisible: false,
      addform: {
        name: "",
        sms_title: "",
        unique_name: "",
        description: "",
        icon: "",
        notice_order_amount: "",
        age: "",
        age_content: "",
        alert_register_to_pay: "",
        is_money_pay: 0,
        is_show: 1,
        close_game: 2,
        service_cost: 0,
        servece_num: 0,
        sort: 999,
      },
      editform: {
        id: "",
        name: "",
        sms_title: "",
        description: "",
        icon: "",
        notice_order_amount: "",
        age: "",
        age_content: "",
        alert_register_to_pay: "",
        remark: "",
        is_money_pay: 0,
        is_show: 1,
        close_game: 2,
        service_cost: 0,
        servece_num: 0,
        sort: 999,
      },
      ageList: [
        { id: 8, name: "8岁" },
        { id: 12, name: "12岁" },
        { id: 16, name: "16岁" },
      ],
      rules: {
        name: [{ required: true, message: "请输入游戏名称", trigger: "blur" }],
        unique_name: [
          { required: true, message: "请输入唯一名称", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.getGameList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    // 高级设置
    advancedFormSubmit () {
      const { id, is_login_suspended, is_kick, login_suspend_status, is_stop_download, is_pay_suspended } = this.advancedForm
      fetch({
        url: "/admin/games/update_crucial_setting",
        method: "POST",
        data: {
          id,
          is_login_suspended,
          is_kick,
          login_suspend_status,
          is_stop_download,
          is_pay_suspended,
        },
      }).then(res => {
        if (res.data.status) {
          this.$message.success('设置成功')
          this.getGameList()
          this.dialogAdvancedVisible = false
        } else {
          this.$message.error('设置失败，原因：' + res.data.message)
        }
      })
    },
    cpAdvanced ({id, is_login_suspended, is_kick, login_suspend_status, is_stop_download, is_pay_suspended}) {
      this.advancedForm = {
        id,
        is_login_suspended,
        is_kick,
        login_suspend_status,
        is_stop_download,
        is_pay_suspended,
      }
      this.dialogAdvancedVisible = true
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getGameList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getGameList(false);
    },
    // 实现游戏数据搜索
    searchGameList() {
      this.currentPage = 1;
      this.getGameList(true);
    },
    // 显示新增游戏对话框
    gameAddDialog() {
      // 清空数据
      this.addform = {
        name: "",
        description: "",
        notice_order_amount: "",
        age: "16",
        age_content: "",
        is_money_pay: 0,
        is_show: 1,
        close_game: 2,
        service_cost: 0,
        servece_num: 0,
        sort: 999,
      };
      this.imageUrl = "";
      this.addDialogFormVisible = true;
    },

    // 导出
    exportGame() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };

      urlSplicing(this.host + "admin/games/list", params);
    },
    // 上传成功回调
    onUploadSuccess(response, file) {
      if (response.status) {
        this.imageUrl = response.data.url;
        this.$message({
          type: "success",
          message: "上传成功",
        });
      }
    },
    // 实现新增游戏提交操作
    addGameSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 实现数据的新增
          this.addform.icon = this.imageUrl;
          fetch({
            url: "/admin/games/create",
            method: "POST",
            data: {
              ...this.addform,
              notice_order_amount: Number(this.addform.notice_order_amount),
              alert_register_to_pay: Number(this.addform.alert_register_to_pay),
            },
          }).then((res) => {
            if (res.data.status === 1) {
              this.$message({
                type: "success",
                message: "添加成功",
              });
              this.getGameList();
              this.addDialogFormVisible = false;
            } else {
              // this.$message({
              //   type: "warning",
              //   message: "数据输入不合法",
              // });
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },

    // 编辑游戏对话框--加载默认数据
    gameEditDialog(row) {
      this.editform.id = row.id;
      this.editform.name = row.name;
      this.editform.sms_title = row.sms_title;
      this.editform.description = row.description;
      this.editform.notice_order_amount = row.notice_order_amount;
      this.editform.alert_register_to_pay = row.alert_register_to_pay;
      this.editform.age = row.age;
      this.editform.age_content = row.age_content;
      this.editform.remark = row.remark;
      this.editform.is_money_pay = row.is_money_pay
      this.editform.is_show = row.is_show
      this.editform.close_game = row.close_game
      this.editform.service_cost = row.service_cost
      this.editform.servece_num = row.servece_num
      this.editform.sort = row.sort
      this.imageUrl = row.icon;
      this.editDialogFormVisible = true;
    },
    // 实现游戏的编辑提交操作
    editGameSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        this.editform.icon = this.imageUrl;
        if (valid) {
          fetch({
            url: "/admin/games/update",
            method: "POST",
            data: {
              ...this.editform,
              notice_order_amount: Number(this.editform.notice_order_amount),
              alert_register_to_pay: Number(this.editform.alert_register_to_pay),
            },
          }).then((res) => {
            if (res.data.status === 1) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.getGameList();
              this.editDialogFormVisible = false;
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },

    //删除
    deleteUser ({id, name}) {
      this.$confirm(`是否删除游戏——${name}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        fetch({
          url: "/admin/games/delete",
          method: "POST",
          data: {
            id: id,
          },
        }).then((res) => {
          if (res.data.status) {
            this.$message.success('删除成功')
            this.getGameList(true)
          }
        })
      })

    },

    // cp对接参数
    cpCopy(id) {
      fetch({
        url: "/admin/games/cp_params",
        method: "GET",
        params: {
          id: id,
        },
      }).then((res) => {
        if (res.data.status) {
          let cpData = res.data.data;
          this.copy(cpData);
        }
      });
    },
    // 复制方法
    copy(data) {
      let cp = data;
      let oTextarea = document.createElement("textarea");
      oTextarea.value = cp;
      document.body.appendChild(oTextarea);
      oTextarea.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success",
      });
      oTextarea.remove();
    },

    // 展示游戏列表数据
    getGameList(reload = false) {
      let searchValue = "";
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      fetch({
        url: "/admin/games/list",
        method: "GET",
        params: {
          name: searchValue,
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
.avatar-uploader {
  img {
    width: 64px;
    height: 64px;
    object-fit: cover;
  }
}
.gameIcon {
  width: 64px;
  height: 64px;
  object-fit: cover;
}
</style>
